import * as Yup from 'yup';
import * as _ from 'lodash';

import FieldUtil from './FieldNames';

const accums = ['active_coverage', 'coinsurance', 'copay', 'deductible', 'oop'];

const accumNodeSchema = Yup.object().shape({
  custom_filters: Yup.string(),
  eb_fields: Yup.object().shape({
    eb_code: Yup.string(),
    in_network: Yup.string(),
    time_period: Yup.string(),
    service_type_code: Yup.string(),
    plan_name: Yup.string()
  }),
  messages: Yup.object().shape({
    include: Yup.string(),
    exclude: Yup.string()
  })
});

const specialtySchema = Yup.object().shape(
  _.fromPairs(accums.map(accum => [
    accum,
    Yup.array().of(accumNodeSchema)
  ]))
);

const twoSeventyOneSchema = Yup.object().shape(
  _.fromPairs(FieldUtil.specialtyKeys.map(specialty => [
    specialty,
    specialtySchema
  ]))
);

const costRulesSchema = Yup.object().shape({
  charge_full_when_missing_ebs: Yup.string(),
  copay_counts_towards_oop: Yup.string(),
  copay_only_fee_for_service: Yup.string(),
  deductible_waived: Yup.string(),
  payment_methods: Yup.object().shape({
    default: Yup.string(),
    when_deductible_is_waived: Yup.string()
  })
});

export const getSchema = props => {
  return Yup.object().shape({
    payer_config: Yup.object().shape({
      active_flg: Yup.string().transform(val => val === 'true' ? 'Y' : 'N'),
      payer_config_settings: Yup.object().shape({
        two_seventy_one: twoSeventyOneSchema,
        cost_rules: costRulesSchema
      })
    })
  });
};
